import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { AuthService } from '@app/services/user/auth/auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable()
export class VoucherAuthorizerInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  /**
   * Intercept Deathstar Subscription or Certification Voucher API with Okta Access Token
   * @inheritdoc
   *
   * Filters requested urls with String.prototype.startsWith to ensure
   * subpaths do not affect this interceptor.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // NOTE: Update URL for any specific apis that require Okta access token in the future
    const urlToMatch = `${environment.voucherApi.url}`;
    if (request.url.startsWith(urlToMatch)) {
      const clone = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.getOktaAccessToken()}`,
          'csdt-authorization-app': 'beyond',
          'x-api-key': `${environment.voucherApi.deathstar_api}`,
          'Content-Type': 'application/json',
        },
      });
      return next.handle(clone);
    } else {
      return next.handle(request);
    }
  }
}
